export default {
    message: {
        currencySymbol: "$",
        currencyDesc: "USD",
        tiers: {
            t1: {
                label: "Workspace Standard",
                desc: "<p>Workspace clé offrant des fonctionnalités intelligentes pour les collaborateurs modernes qui utilisent des applications Web et SaaS, et des services de partage de fichiers.</p><p>Comprend une fonction d’authentification unique avec la prise en charge de l’authentification multifacteur pour toutes les applications, une fonction d’intelligence avec microapplications, flux personnalisés et assistance virtuelle, et le service Citrix Content Collaboration Standard avec stockage de fichiers illimité.</p>"
            },
            t2: {
                label: "Workspace Premium",
                desc: "<p>Solution complète d’espace de travail pour les collaborateurs ayant besoin d’un espace de travail digital assorti d’une sécurité granulaire, mais qui n’ont pas besoin d’applications et de postes virtuels.</p><p>Comprend les fonctionnalités de Workspace Standard, ainsi que des contrôles de sécurité avancés pour les SaaS et le Web, la gestion unifiée des terminaux et Content Collaboration Premium.</p>"
            },
            t3: {
                label: "Workspace Premium Plus",
                desc: "<p>Solution complète d’espace de travail comprenant des options de déploiement hybride pour Citrix Virtual Apps and Desktops.</p><p>Comprend les fonctionnalités de Workspace Premium, ainsi qu’une option de gestion de cloud pour Citrix Virtual Apps and Desktops.</p>"
            },
            t4: {
                label: "Workspace Essentials",
                desc: "<p>Citrix Workspace Essentials aide les petites et moyennes entreprises à protéger leurs données en simplifiant et en sécurisant le processus de connexion aux applications Web et SaaS.</p><p>Comprend une fonction d’authentification unique pour les applications Web et SaaS avec une authentification multifacteur pour renforcer la sécurité du processus de connexion, réduisant ainsi le risque de mise en danger des comptes de 99,9 %.</p>"
            },
            terms: "*Par utilisateur et par mois",
            btn1: "Voir la matrice des fonctionnalités"
        },
        features: {
            disclaimer1: "*Prix de vente suggéré en USD par utilisateur par mois pour 500 utilisateurs avec un abonnement annuel de 3 ans. Le prix réel peut varier.<br /> Options de licences Citrix Workspace à partir de 25 utilisateurs.",
            disclaimer2: "**Le service Workspace Premium ne comprend pas Workspace Analytics pour les déploiements de Citrix Virtual Apps and Desktops sur site."
        },
        calculator: {
            edition: "Choisissez votre édition",
            title: "Calculez votre prix",
            users: "Sélectionnez vos utilisateurs",
            estCost: "Estimation de coût mensuel",
            btn1: "Parler à un expert",
            btn1_link: "/products/citrix-workspace/form/pricing-inquiry/",
            minUserMsg: "Options de licences à partir de 25 utilisateurs. Veuillez réessayer.",
            lowUserMsg: "Vous avez moins de 500 utilisateurs ? Nous sommes là pour répondre aux besoins de votre petite ou moyenne entreprise.",
            volumeDiscount: "Vous avez plus de 2 500 utilisateurs ? Profitez d’une réduction de prix sur le volume.",
            contract1: "Contrat d’un an",
            contract3: "Contrat de trois ans",
            contract3savings: "20 % d’économies",
            term: "Par utilisateur et par mois",
            disclaimer: "*Cet outil de calcul fournit une estimation de prix à des fins de budgétisation uniquement. Les prix réels peuvent varier. Contactez votre équipe ou votre partenaire Citrix pour connaître les réductions applicables."
        },
        stats: {
            title: "Vos avantages",
            stat1: {
                title: "Améliorez l’expérience collaborateur",
                desc: "<b>4 responsables informatiques sur 5</b> considèrent que l’expérience collaborateur est indispensable à la transformation digitale."
            },
            stat2: {
                title: "Donnez le choix à vos collaborateurs",
                desc: "<b>78 %</b> des responsables d’entreprise reconnaissent que permettre aux collaborateurs de choisir leurs applications et leurs appareils contribue à améliorer l’expérience collaborateur."
            },
            stat3: {
                title: "Simplifiez l’accès",
                desc: "<b>47 %</b> des responsables d’entreprise rapportent que la contribution la plus importante à l’engagement des collaborateurs est la facilité d’accès aux informations nécessaires au travail."
            },
            btn1: "Parler à un expert",
            disclaimer: "Source : <a href='https://theexperienceofwork.economist.com/Citrix_The_Experience_of_Work_BriefingPaper.pdf' target='_blank'>The Economist</a>"
        }
    }
}